import React, { useEffect, useRef, useState } from 'react';

import { Box, xcss } from '@atlaskit/primitives';

import { QuickFind } from './QuickFind';

export const QuickFindNav3 = () => {
	const [isQuickFindOpen, setIsQuickFindOpen] = useState(false);
	const [height, setHeight] = useState(0);
	const ref = useRef<HTMLElement>(null);

	useEffect(() => {
		if (ref.current) {
			setHeight(ref.current.offsetHeight);
		}
	}, [ref, setHeight, isQuickFindOpen]);

	return (
		<Box
			testId="quick-find-container"
			xcss={[searchBarWrapper]}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
			style={height ? { height } : {}}
		>
			<Box xcss={[isQuickFindOpen && searchBarExpanded]} ref={ref}>
				<QuickFind onToggle={(open) => setIsQuickFindOpen(open)} />
			</Box>
		</Box>
	);
};

const searchBarWrapper = xcss({
	position: 'relative',
	width: '200px',
});

const searchBarExpanded = xcss({
	position: 'absolute',
	top: 'space.0',
	right: 'space.0',
	width: '780px',
});
